import React from 'react';

import Table from 'components/Table';

const YearSplitter = ({year, advancedMode}) => {
  return (
    <Table.Row className="scheduleRow yearSplitter">
      <Table.Cell className="booking" />
      <Table.Cell className="date colab-bold">{year}</Table.Cell>
      {advancedMode && <Table.Cell className="dueDate" />}
      <Table.Cell className="type" />
      <Table.Cell className="description" />
      <Table.Cell className="category" />
      <Table.Cell className="status" />
      {advancedMode && <Table.Cell className="due" />}
      <Table.Cell className="amount" />
      <Table.Cell className="balance" />
      <Table.Cell className="mode" />
    </Table.Row>
  );
};

export default YearSplitter;
